import * as XLSX from 'xlsx';

export const generateExcelData = (
  fetchedData: any[],
  tableTitle: string,
  columnOrderMap: Record<string, string[]>,
  sheetTitles: string[],
  columnHeadersMap: Record<number, string[]>,
) => {
  if (!fetchedData || fetchedData.length === 0) {
    throw new Error('No data available');
  }

  let orderedKeys: string[] = [];
  if (Array.isArray(fetchedData) && fetchedData.length > 0) {
    orderedKeys = Object.keys(fetchedData[0]);
  } else if (typeof fetchedData === 'object' && fetchedData !== null) {
    orderedKeys = Object.keys(fetchedData);
  }
  const mappedKeys = columnOrderMap[tableTitle];

  if (
    mappedKeys &&
    mappedKeys.length &&
    fetchedData.length > 0 &&
    mappedKeys.every((key) => key in fetchedData[0])
  ) {
    orderedKeys = mappedKeys;
  } else {
    console.warn(
      `Column mapping mismatch for ${tableTitle}, falling back to data keys`,
    );
    orderedKeys = Object.keys(fetchedData[0]);
  }

  const index = sheetTitles.indexOf(tableTitle);
  if (index === -1) {
    throw new Error(`Table title "${tableTitle}" not found in sheetTitles`);
  }
  const headers = columnHeadersMap[index] || [];

  let reorderedData: Record<string, any>[] = [];

  if (Array.isArray(fetchedData)) {
    reorderedData = fetchedData.map((item: Record<string, any>) =>
      orderedKeys.reduce(
        (acc, key) => {
          const value = item[key];

          acc[key] =
            (key === 'iso_code' || key === 'country_name') &&
            typeof value === 'string'
              ? value.slice(0, 2)
              : (value ?? '');

          return acc;
        },
        {} as Record<string, any>,
      ),
    );
  } else if (typeof fetchedData === 'object' && fetchedData !== null) {
    reorderedData = [
      orderedKeys.reduce(
        (acc, key) => {
          const value = (fetchedData as Record<string, any>)[key];

          acc[key] =
            (key === 'iso_code' || key === 'country_name') &&
            typeof value === 'string'
              ? value.slice(0, 2)
              : (value ?? '');

          return acc;
        },
        {} as Record<string, any>,
      ),
    ];
  } else {
    console.log('Unexpected data format for fetchedData:', fetchedData);
  }

  const data = [
    headers,
    ...reorderedData.map((item) => orderedKeys.map((key) => item[key])),
  ];

  const ws = XLSX.utils.aoa_to_sheet(data);
  const wb = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(wb, ws, tableTitle);

  return { wb, title: tableTitle };
};
